import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

import { useCancelToken } from 'component/core/cancel-token';
import { getBill, getBillChecked, getBillId } from 'component/api/main';
import { timeToSeconds } from '../utils';

import { IDataBill } from 'component/api/types/api/main/get-bill/get/code-200';

const useRequestBill = () => {
    const token = useCancelToken();
    const tokenChecked = useCancelToken();

    const [data, setData] = useState<IDataBill | null>(null);
    const [pending, setPending] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        return () => {
            token.remove();
            tokenChecked.remove();
        };
    }, []);

    const requestBill = useCallback((bill_id?: number, call_back?: () => void): void => {
        setPending(true);
        setError(null);

        const api = bill_id
            ? getBillId(bill_id, {
                cancelToken: token.new()
            })
            : getBill({
                cancelToken: token.new()
            });

        api
            .then((resp) => {
                const operations = (resp.operations || []).map((item) => ({
                    ...item,
                    timeSec: timeToSeconds(item.time_of_operation)
                }));

                setData({ ...resp, operations });
                call_back && call_back();
                setPending(false);
            })
            .catch((err) => {
                if (!axios.isCancel(err)) {
                    setPending(false);
                    setError(`(${err.response?.status}) ${err.response?.data?.error}` || 'Ошибка обработки данных');
                }
            });
    }, [token]);

    const requestBillChecked = useCallback((bill_id: number, call_back?: () => void): void => {
        setPending(true);
        setError(null);

        getBillChecked(bill_id, {
            cancelToken: tokenChecked.new()
        })
            .then((resp) => {
                if (resp.result === 'success') {
                    setData(null);
                    call_back && call_back();
                } else {
                    throw resp.result;
                }
                setPending(false);
            })
            .catch((err) => {
                if (!axios.isCancel(err)) {
                    setPending(false);
                    setError(`(${err.response?.status}) ${err.response?.data?.error}` || 'Ошибка обработки данных');
                }
            });
    }, [tokenChecked]);

    return {
        data,
        pending,
        error,
        requestBill,
        requestBillChecked
    };
};

export default useRequestBill;
